export default __webpack_public_path__ + "static/media/news1.05b8a40a.jpg";